import { useState } from "react";

import domain from "../domain";
import classes from "./ExternalRating.module.css";

// == for Google Review Link , its stored at two places 1. in the FeedbackForm collection, so
// that when cusotmer fills feedback form they can be redirected to google review form
// 2. in the admin collection so that when seeing profile admin is able to see their strored
// link,

function linkTestHandler(link) {
  let l = link;
  let beginning = l.substr(0, 4);

  if (beginning != "http") {
    l = `https://${l}`;
  }
  window.open(l, "_blank", "noopener,noreferrer");
  return null;
}


export default function ExternalRating({ data }) {
  const [link, setLink] = useState(data?.link);
  const [platform, setPlatform] = useState(data?.platform);
  const [message, setMessage] = useState(data?.message);

  async function saveLinkHandler() {
    console.log("save link");
    console.log(link);
    console.log(data);

    let feedbackId = JSON.parse(localStorage.getItem("questions"));
    console.log(feedbackId._id);
    let myData = {
      feedbackId: feedbackId,
      link: link,
      platform: platform,
      message: message,
    };

    try {
      const data1 = await fetch(`${domain}/api/externalreview`, {
        method: "PATCH",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify(myData),
      });
      //   localStorage.setItem("pdata", JSON.stringify(myData));
      const data = await data1.json();

      localStorage.setItem("questions", JSON.stringify(data));

      //  return data;
    } catch (err) {}
  } // end of saveLinkHandler

  function linkHandler(e) {
    console.log("link changed ");

    setLink(e.target.value);
  }
  function messageHandler(e) {
    setMessage(e.target.value);
  }
  function platformHandler(e) {
    console.log("link changed");
    console.log(e.target.value);
    setPlatform(e.target.value);
  }

  return (
    <div className={classes.card}>
      <h3>External Rating</h3>
      <p className={classes.intro}>
        Where customers go after feedback, and the note they see before they leave.
      </p>
      <div className={classes.form}>
        <label>
          Platform
          <input
            name="platform"
            type="text"
            placeholder="Google, TripAdvisor"
            defaultValue={data?.platform}
            onChange={platformHandler}
          />
        </label>
        <label>
          Message
          <textarea
            name="message"
            rows={3}
            placeholder="Enjoyed your visit? A public review helps us a lot."
            defaultValue={data?.message}
            onChange={messageHandler}
          />
        </label>
        <label>
          Review link
          <input
            name="link"
            type="url"
            placeholder="https://"
            defaultValue={data?.link}
            onChange={linkHandler}
          />
        </label>
        <div className={classes.actions}>
          <button
            type="button"
            className={classes.secondary}
            onClick={() => linkTestHandler(link)}
          >
            Test link
          </button>
          <button
            type="button"
            className={classes.primary}
            onClick={saveLinkHandler}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
